import { auth } from "../constants/actionTypes";

export const REQUEST_TRACKING_RECORDED = "requestTracking/recorded";
export const REQUEST_TRACKING_CLEARED = "requestTracking/cleared";

const MAX_ENTRIES = 100;

const defaultState = {
  entries: [],
  lastError: null
};

/**
 * @param {Object} entry
 * @returns {{ type: string, payload: Object }}
 */
export function recordRequest(entry) {
  return {
    type: REQUEST_TRACKING_RECORDED,
    payload: entry
  };
}

export function clearRequestTracking() {
  return {
    type: REQUEST_TRACKING_CLEARED
  };
}

function isFailedRequest(entry) {
  if (entry.errorMessage) {
    return true;
  }

  if (entry.status == null) {
    return true;
  }

  return entry.status >= 400;
}

export default function requestTracking(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case REQUEST_TRACKING_RECORDED: {
      const entries = [payload, ...state.entries].slice(0, MAX_ENTRIES);
      const lastError = isFailedRequest(payload)
        ? {
            requestId: payload.requestId,
            url: payload.url,
            errorMessage: payload.errorMessage || `HTTP ${payload.status}`,
            timestamp: payload.timestamp
          }
        : state.lastError;

      return {
        entries,
        lastError
      };
    }

    case REQUEST_TRACKING_CLEARED:
    case auth.LOGOUT:
      return defaultState;

    default:
      return state;
  }
}
